import { useState } from "react";
import { groupApi } from "../api/group.service";

export const useImportAttendants = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const mutation = async (
    group_id: string,
    payload: {
      pwd_group: string;
      attendants: Record<string, string>[];
    },
  ) => {
    try {
      setLoading(true);

      const response: any = await groupApi.importAttendantData(
        group_id,
        payload,
      );

      return {
        success: response?.data?.data?.success,
        message: response?.data?.message,
        data: response?.data?.data,
        error: response?.data?.data?.errors,
      };
    } catch (err: any) {
      console.log("Import attendants failed:", err);

      return {
        success: false,
        message: err?.message || "Something wrong",
        data: null,
        error: err?.data?.data?.errors,
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    mutation,
    loading,
  };
};
